// extracted by mini-css-extract-plugin
export default {"cta":"GH-z","disabled":"HH-z"};